import { get, put } from "./apiClient";

export default {
  async get(locationId) {
    return await get(
      `location/${encodeURIComponent(locationId)}/performanceThresholds`
    );
  },
  async put(locationId, performanceThresholds) {
    await put(
      `location/${encodeURIComponent(locationId)}/performanceThresholds`,
      performanceThresholds
    );
  }
};
